import {axiosInstance} from "@/plugins/axios";
import {ProductSpecificRuleFilter} from "@/modules/product_specific_rule/types";

export async function getProductSpecificRule(id: string) {
  const response = await axiosInstance.get(`product_specific_rules/${id}`);
  return response.data;
}

export async function getProductSpecificRules(payload: ProductSpecificRuleFilter) {
  let url = `product_specific_rules?`;

  if (payload && payload.harmonized_system_code !== "") {
    url += `&harmonized_system_code=${payload.harmonized_system_code}`
  }

  if (payload && payload.start_application_date !== "" && payload.end_application_date !== "") {
    url += `&start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}`
  }

  if (payload && payload.id_agreement !== "") {
    url += `&id_agreement=${payload.id_agreement}`
  }

  const response = await axiosInstance.get(url);

  return response.data;
}
